import type { ApolloCache } from '@apollo/client'
import { gql } from '@apollo/client'

const REVISION_DESCRIPTION_FRAGMENT = gql`
    fragment RevisionDescription on Revision {
        guid
        description
    }
`

type UpdatedRevision = {
    guid: string
    description?: string | null
}

export const updateRevisionDescriptionCache = (
    cache: ApolloCache,
    updatedRevision: UpdatedRevision | null | undefined,
) => {
    if (!updatedRevision?.guid) {
        return
    }

    cache.writeFragment({
        fragment: REVISION_DESCRIPTION_FRAGMENT,
        data: {
            __typename: 'Revision',
            guid: updatedRevision.guid,
            description: updatedRevision.description,
        },
    })
}
